import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function GearIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd" d="M19.1997 10.1997H19.0318C18.6104 10.1997 18.2455 9.91355 18.0868 9.52316C17.9078 9.08289 17.9731 8.57099 18.3094 8.23518L18.3633 8.1813C19.0668 7.4778 19.0668 6.3387 18.3633 5.6343C17.6598 4.9326 16.521 4.9326 15.8184 5.6343L15.7292 5.7234C15.4126 6.03974 14.931 6.10166 14.5178 5.92967C14.1047 5.75774 13.8003 5.37063 13.8003 4.92315V4.8003C13.8003 3.8049 12.9939 3 12 3C11.0061 3 10.1997 3.8049 10.1997 4.8003V4.87776C10.1997 5.3521 9.87765 5.76183 9.44092 5.94694C9.05278 6.11147 8.59891 6.05228 8.30095 5.75404L8.18132 5.6343C7.47902 4.9326 6.33872 4.9326 5.63552 5.6343C4.93262 6.3387 4.93262 7.4778 5.63552 8.1813L5.72254 8.26819C6.03942 8.58462 6.1018 9.06662 5.93015 9.48024C5.75823 9.89452 5.3705 10.1997 4.92196 10.1997H4.80032C3.80582 10.1997 3.00002 11.0058 3.00002 12C3.00002 12.9939 3.80582 13.8003 4.80032 13.8003H4.9226C5.3708 13.8003 5.7582 14.1048 5.93033 14.5187C6.10202 14.9314 6.04036 15.4128 5.72456 15.7292L5.63552 15.8184C4.93262 16.521 4.93262 17.6598 5.63552 18.3633C6.33872 19.0668 7.47902 19.0668 8.18132 18.3633L8.2692 18.2755C8.58587 17.9591 9.06821 17.8978 9.48167 18.0693C9.89539 18.2409 10.1997 18.6278 10.1997 19.0757V19.1997C10.1997 20.1942 11.0061 21 12 21C12.9939 21 13.8003 20.1942 13.8003 19.1997V19.0749C13.8003 18.6275 14.1048 18.2409 14.518 18.0694C14.9311 17.8979 15.4128 17.9588 15.7295 18.2747L15.8184 18.3633C16.521 19.0668 17.6598 19.0668 18.3633 18.3633C19.0668 17.6598 19.0668 16.521 18.3633 15.8184L18.2758 15.7307C17.9592 15.4135 17.8978 14.9307 18.0697 14.5169C18.2414 14.1037 18.6283 13.8003 19.0757 13.8003H19.1997C20.1942 13.8003 21 12.9939 21 12C21 11.0058 20.1942 10.1997 19.1997 10.1997Z" fill="#BCBBD0" />
			<circle cx="12" cy="12" r="3" fill="white" />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<GearIcon fill={props.fill} />
		</div>
	);
}